/* Newsletter popup — behaviour for sections/newsletter-popup.liquid (Oct 2026; v3.3 27 Oct, v3.4c/d 28 Oct 2026).
   Notes: planning/crm-klaviyo-2026-10/build/forms/IMPLEMENTATION.md, v3.1: planning/crm-klaviyo-2026-10/build/
   v3-1-2026-10-26/FORMS-v3.1.md, v3.2: planning/crm-klaviyo-2026-10/build/subscription-2026-10-27/POPUP-v3.2.md,
   v3.3: …/subscription-2026-10-27/v33/SPEC.md, v3.4: …/subscription-2026-10-27/v34-prototype/PROTOTYPE.md (§0, §7)
   and …/subscription-2026-10-27/v34-theme/BUILD.md

   - „Deckel auf": two arms. „reveal" opens on step S1 (heading with the 5 €, the offer line, the Set with the closed
     Dose, the button „Deckel auf"); „single" opens on the form with the Set photo. The arm: data-np-reveal (rendered
     only with the v3.4 layers; never „data-reveal": that is base.css/global.js's scroll reveal, opacity 0 until
     .revealed) = off | on | alternate (even Berlin day number = reveal); ?np_step=dose|form overrides it for testing;
     no photo band (phones ≤ 560 px tall), forced colours, no container-query units (the scene is sized in cqh/cqw), a
     Files photo or a layer that is not loaded and decoded when the popup opens → single (fail closed). Success, error and the editor's re-render never show S1. The
     popup's tags get pv-reveal / pv-single (what was shown); nothing new is stored.
   - v3.4 reveal (ported from the v3.4c prototype; Web Animations API, no CSS keyframes): one tap (button, picture,
     Enter/Space) or an upward drag that starts on the Dose: the tin squashes and hops, the lid pops off its right flange, arcs
     up-left and lands leaning on the Dose (handover to the real photo of the leaning lid), fine powder above the rim
     (seeded canvas), the „5 € / CODE" card springs out of the opening and stays standing in it; „Deckel auf" fades and
     the form rises in under the same offer line. 1 250 ms; the form is live at 600 ms; a second tap (or Enter/Space)
     skips to the end; taps within 400 ms of the first can't land on the field or „Anmelden". The end state is held by
     classes (.is-open-tin), so no animation is left afterwards. Focus: the heading on open, the offer line after the
     reveal (unless the visitor is already in the form). Idle: two small wobbles (0,9 s and 3,7 s, done by 4,6 s:
     WCAG 2.2.2); hover/keyboard focus lifts the lid a little. Android: an 8 ms haptic tick at the pop (only with user
     activation). Reduced motion: no wobble, peek, drag, particles or haptics; a 200 ms opacity handover.
   - The layer images carry data-src/data-srcset; they get their URLs when the popup is armed in arm „reveal" (so a
     page view that never shows the popup loads none of them) and are decoded before the sheet opens.
   - The code conditions wait in the offer <template> and the „Bedingungen" listener in
     snippets/newsletter-form.liquid copies them into the panel on the first tap (also for the footer), so the code
     price is not part of the rendered page before that (critic #18). The Set photo is loading="lazy" inside the closed
     dialog; once the popup is armed in arm „single", it switches to eager, so it is there when it opens.

   - Opens only after the cookie banner has been answered (Shopify Customer Privacy API: currentVisitorConsent() holds
     'yes'/'no' for a purpose; '' everywhere = not answered yet. The *Allowed() getters return true when there is no
     consent data at all, so they can't tell "answered"). Visitors outside the banner regions never answer, so they
     never see the popup — deliberate: the dialog is modal, and a banner appearing under it would be unreachable.
   - Armed the moment the banner is answered (Shopify's visitorConsentCollected event), or as soon as the page is
     ready (DOMContentLoaded + the privacy API) when it was answered on an earlier visit. v3.2: founder 26 Oct, „8
     seconds after you clicked away the cookie banner": data-delay = 8 by default (0 is allowed), the scroll trigger
     is off by default (data-scroll 0).
   - Then after data-delay seconds or data-scroll % of the page (if > 0), whichever comes first; never while the cookie banner,
     the cart drawer, the menu (pre-launch .launch-header.is-menu-open or the post-launch [data-menu-drawer]), another
     dialog or a focused text field is in use (it waits and tries again).
   - Storage: the theme stores ONE flag „closed = 1“, no ID, written when the popup opens, is closed or a sign-up was
     sent (popup or footer), so it doesn't ask again in the same browser session. v3.3.1: kept in sessionStorage AND as
     a session cookie (no Expires/Max-Age, path=/, SameSite=Lax): sessionStorage is per tab and a new tab (the
     „Datenschutz“ links open one) started without it, so the popup came back there. Either one counts. No
     localStorage. Shopify's
     captcha bootstrap additionally keeps the submitted form fields (incl. the e-mail) in sessionStorage under a random
     form_key, so it can refill the form after a challenge; that is Shopify's, not this file's.
   - On submit the dialog leaves the top layer (showModal → show) before Shopify's hCaptcha runs: its challenge is
     appended to <body>, which a modal dialog makes inert and paints over.
   - After a POST Shopify reloads the page with #<form id>; customer-form state is page-wide, so the form that was not
     sent hides its copy of it and loses its invalid marking. The popup reopens once to show its own success or error.
   - Theme editor: never opens by itself and stores nothing; selecting the section opens it.
   Plain ES5 (like cart-drawer.js), plus Promise and the Web Animations API where present. */
(function () {
  'use strict';

  var FLAG = 'addit-newsletter-popup-closed';
  var BLOCKERS = 'body.drawer-open, [data-menu-drawer].is-open, .launch-header.is-menu-open, html.amino-sheet-lock';
  var CLOSE_MS = 280;
  // v3.4 reveal timing (ms): total, reduced-motion handover, form live, double-tap guard, powder window
  var TOTAL = 1250;
  var TOTAL_RM = 200;
  var LIVE_AT = 600;
  var GUARD = 400;
  var PUFF_START = 100;
  var PUFF_END = 920;

  function flagged() {
    try { if (window.sessionStorage.getItem(FLAG) === '1') return true; } catch (e) {}
    try { return document.cookie.split(/;\s*/).indexOf(FLAG + '=1') !== -1; } catch (e2) { return false; }
  }
  function setFlag() {
    try { window.sessionStorage.setItem(FLAG, '1'); } catch (e) {}
    // Session cookie (no expiry): dies with the browser session like sessionStorage, but every tab sees it
    try { document.cookie = FLAG + '=1; path=/; SameSite=Lax' + (window.location.protocol === 'https:' ? '; Secure' : ''); } catch (e2) {}
  }

  function mq(q) {
    try { return !!(window.matchMedia && window.matchMedia(q).matches); } catch (e) { return false; }
  }
  function reduced() { return mq('(prefers-reduced-motion: reduce)'); }

  // The Set photo (arm „single", and the fallback): lazy → eager once armed
  function preloadPhoto(dlg) {
    var imgs = dlg.querySelectorAll('img[data-newsletter-popup-img]');
    for (var i = 0; i < imgs.length; i++) {
      try { imgs[i].loading = 'eager'; } catch (e) { imgs[i].setAttribute('loading', 'eager'); }
    }
  }

  // Resolves true when the image is loaded and decoded, false when it failed
  function decoded(img) {
    if (typeof Promise === 'undefined') return null;
    if (typeof img.decode === 'function') {
      return img.decode().then(function () { return img.naturalWidth > 0; }, function () { return false; });
    }
    return new Promise(function (resolve) {
      if (img.complete) { resolve(img.naturalWidth > 0); return; }
      img.addEventListener('load', function () { resolve(img.naturalWidth > 0); });
      img.addEventListener('error', function () { resolve(false); });
    });
  }

  // Spring easing as CSS linear() (damped harmonic oscillator, sampled); fallback: an overshooting bezier
  function spring(stiffness, damping) {
    var ok = false;
    try { ok = !!(window.CSS && CSS.supports && CSS.supports('animation-timing-function', 'linear(0, 0.5, 1)')); } catch (e) {}
    if (!ok) return 'cubic-bezier(0.34, 1.56, 0.64, 1)';
    var w0 = Math.sqrt(stiffness), z = damping / (2 * w0), wd = w0 * Math.sqrt(1 - z * z);
    var settle = Math.log(1 / 0.002) / (z * w0), n = 48, pts = [];
    for (var i = 0; i <= n; i++) {
      var t = settle * i / n;
      var x = 1 - Math.exp(-z * w0 * t) * (Math.cos(wd * t) + (z * w0 / wd) * Math.sin(wd * t));
      pts.push(i === n ? 1 : Math.round(x * 10000) / 10000);
    }
    return 'linear(' + pts.join(', ') + ')';
  }

  // Berlin calendar day number (days since 1970-01-01): even = reveal, odd = single (SPEC §8.2). Fri 30 Oct 2026 =
  // 20756. Falls back to the local date where Intl or the time zone is missing.
  function berlinDay(now) {
    var y, m, d;
    try {
      var p = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now).split('-');
      y = parseInt(p[0], 10); m = parseInt(p[1], 10); d = parseInt(p[2], 10);
      if (!y || !m || !d) throw new Error('date');
    } catch (e) {
      y = now.getFullYear(); m = now.getMonth() + 1; d = now.getDate();
    }
    return Math.round(Date.UTC(y, m - 1, d) / 864e5);
  }

  // Testing override, any theme: ?np_step=dose | form
  function stepOverride() {
    var m = /[?&]np_step=(dose|form)(&|$)/.exec(window.location.search || '');
    return m ? m[1] : null;
  }

  function shown(el) {
    if (!el || !el.getClientRects().length) return false;
    var cs = window.getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none';
  }

  function consentAnswered(cp) {
    if (!cp || typeof cp.currentVisitorConsent !== 'function') return false;
    try {
      var c = cp.currentVisitorConsent() || {};
      return !!(c.marketing || c.analytics || c.preferences || c.sale_of_data);
    } catch (e) {
      return false;
    }
  }

  // The API is not always on Online Store pages; load it as sections/hive-customer-portal.liquid does. v3.2: version
  // '0.2' as in Shopify's current docs (checked on the preview 27 Oct: loads, same getters), '0.1' as the fallback.
  function withPrivacyApi(cb) {
    var S = window.Shopify;
    if (S && S.customerPrivacy) { cb(S.customerPrivacy); return; }
    if (S && typeof S.loadFeatures === 'function') {
      var load = function (version, next) {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: version }], function (error) {
          var cp = (window.Shopify && window.Shopify.customerPrivacy) || null;
          if ((error || !cp) && next) { next(); return; }
          cb(error ? null : cp);
        });
      };
      load('0.2', function () { load('0.1', null); });
      return;
    }
    cb(null);
  }

  function init(dlg) {
    if (!dlg || dlg.getAttribute('data-bound') === '1') return;
    dlg.setAttribute('data-bound', '1');

    var design = dlg.hasAttribute('data-design-mode') || !!(window.Shopify && window.Shopify.designMode);
    var formId = dlg.getAttribute('data-form-id') || 'newsletter-popup';
    var form = document.getElementById(formId);
    var closeBtn = dlg.querySelector('[data-newsletter-popup-close]');
    // 0 is a valid delay (open right after the banner); a missing or broken value falls back to 8 s / scroll off
    var delayS = parseInt(dlg.getAttribute('data-delay'), 10);
    if (isNaN(delayS) || delayS < 0) delayS = 8;
    var delay = delayS * 1000;
    var depthP = parseInt(dlg.getAttribute('data-scroll'), 10);
    if (isNaN(depthP) || depthP < 0) depthP = 0;
    var depth = depthP / 100; // 0 = no scroll trigger
    var opener = null;
    var closing = false;
    var finished = false;
    var armed = false;
    var timer = null;
    var retry = null;
    var ticking = false;
    var downOnBackdrop = false;
    var modal = false; // true while the dialog is in the top layer (showModal)
    // Steps
    var stage = dlg.querySelector('[data-newsletter-stage]');
    var doseStep = dlg.querySelector('[data-newsletter-step="dose"]');
    var formStep = dlg.querySelector('[data-newsletter-step="form"]');
    var revealBtn = dlg.querySelector('[data-newsletter-reveal]');
    var media = dlg.querySelector('[data-newsletter-reveal-media]');
    var title = dlg.querySelector('.newsletter-popup__title');
    var line = dlg.querySelector('.newsletter-popup__text');
    var input = form ? form.querySelector('input[type="email"]') : null;
    var tags = form ? form.querySelector('input[name="contact[tags]"]') : null;
    var baseTags = tags ? tags.value : ''; // as rendered; pv-* is appended to this, never twice
    var shownArm = 'single'; // „reveal“ or „single“ (not „arm“: that is the timer function below)
    var settleTimer = null; // tap guard
    // v3.4 layers
    var scene = dlg.querySelector('[data-newsletter-scene]');
    var q = function (s) { return scene ? scene.querySelector(s) : null; };
    var group = q('[data-np-group]');
    var tin = q('[data-np-tin]');
    var lid = q('[data-np-lid]');
    var lidWrap = q('[data-np-lid-wrap]');
    var chip = q('[data-np-chip]');
    var chipIn = q('[data-np-chip-in]');
    var cloud = q('[data-np-cloud]');
    var shadow = q('[data-np-shadow]');
    var lean = q('[data-np-lean]');
    var leanShadow = q('[data-np-lean-shadow]');
    var fx = q('[data-np-fx]');
    // The scene is sized in container-query units (cqh/cqw): a browser with the Web Animations API but without them
    // (e.g. iOS 15.4–15.8) would collapse the group to 0 × 0, so it gets the single step
    var cqOk = false;
    try { cqOk = !!(window.CSS && CSS.supports && CSS.supports('height', '1cqh')); } catch (e) {}
    var canAnimate = !!(cqOk && scene && group && tin && lid && lidWrap && chip && chipIn && cloud && shadow && lean && leanShadow &&
      typeof tin.animate === 'function' && typeof window.Animation === 'function' && typeof window.KeyframeEffect === 'function');
    var layers = 'none'; // none | loading | ready | failed
    var SPRING_CHIP = canAnimate ? spring(170, 14) : ''; // ~13 % overshoot: the small bounce
    // reveal state: idle (S1 waiting) | revealing | done
    var rstate = 'done';
    var anims = [];      // the running reveal animations (all start together, so one clock)
    var master = null;   // target-less clock: carries the total duration; its finish ends the reveal
    var idleAnims = [];
    var idleTimers = [];
    var liveTimer = null;
    var pressTimer = null;
    var rafId = 0;
    var formLive = false;
    var timing = { start: 0, live: 0, end: 0, skipped: false, from: '' };

    function isOpen() { return dlg.hasAttribute('open'); }

    // „reveal" or „single" (SPEC §8.2). The editor shows S1 for on and alternate alike.
    function chooseArm() {
      var setting = dlg.getAttribute('data-np-reveal');
      if (!setting || !doseStep || !revealBtn || !formStep || !canAnimate) return 'single';
      // Landscape phones (≤ 560 px tall): below 768 px wide the picture band is hidden (CSS), and wider ones get a short
      // split dialog whose text column scrolls; a lid button without a lid is pointless, so the form
      if (mq('(max-height: 560px)')) return 'single';
      // Forced colours: the pictures are decoration and hidden there; the form at once
      if (mq('(forced-colors: active)')) return 'single';
      var o = stepOverride();
      if (o) return o === 'dose' ? 'reveal' : 'single';
      if (setting === 'on') return 'reveal';
      if (setting === 'alternate') return (design || berlinDay(new Date()) % 2 === 0) ? 'reveal' : 'single';
      return 'single';
    }

    // v3.4: the layer images get their URLs (armed in arm „reveal", or in the editor) and are decoded; until every one
    // has decoded, `layers` is not „ready" and open() falls back to the single step (fail closed)
    function loadLayers() {
      if (!scene || layers !== 'none') return;
      layers = 'loading';
      var imgs = scene.querySelectorAll('img[data-np-layer]');
      var waits = [];
      for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i];
        var ss = img.getAttribute('data-srcset');
        if (ss) img.setAttribute('srcset', ss);
        img.setAttribute('src', img.getAttribute('data-src'));
        waits.push(decoded(img));
      }
      // a failed layer means the single step with the Set photo: start loading that photo now, not at open
      if (typeof Promise === 'undefined' || waits.indexOf(null) !== -1) { layers = 'failed'; preloadPhoto(dlg); return; }
      Promise.all(waits).then(function (oks) {
        layers = oks.indexOf(false) === -1 ? 'ready' : 'failed';
        if (layers === 'failed') preloadPhoto(dlg);
      });
    }

    function setArm(a) {
      shownArm = a;
      dlg.setAttribute('data-arm', a);
      if (tags) tags.value = baseTags + ',pv-' + a;
    }

    function setStep(step) {
      if (stage) stage.setAttribute('data-step', step);
      dlg.setAttribute('data-step', step);
      if (doseStep) {
        if (step === 'dose') doseStep.removeAttribute('inert'); else doseStep.setAttribute('inert', '');
      }
      if (formStep && doseStep) {
        if (step === 'form') formStep.removeAttribute('inert'); else formStep.setAttribute('inert', '');
      }
    }

    // Closes the „Bedingungen" panel and resets every toggle that controls it
    function closeConditions() {
      var panel = dlg.querySelector('[data-newsletter-more]');
      if (!panel || panel.hidden) return;
      panel.hidden = true;
      var all = dlg.querySelectorAll('[data-newsletter-more-toggle]');
      for (var i = 0; i < all.length; i++) {
        if (all[i].getAttribute('aria-controls') === panel.id) all[i].setAttribute('aria-expanded', 'false');
      }
    }

    function focusEl(el) {
      if (!el) return;
      try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
    }

    // ------------------------------------------------------------------------------------------ idle invitation
    function wobble() {
      if (rstate !== 'idle' || !isOpen() || reduced() || dlg.classList.contains('is-peek') || dragging) return;
      var o = { duration: 900, easing: 'ease-in-out' };
      idleAnims = [
        tin.animate([
          { transform: 'rotate(0deg)' },
          { transform: 'rotate(-3.5deg)', offset: 0.18 },
          { transform: 'rotate(3deg)', offset: 0.4 },
          { transform: 'rotate(-1.6deg)', offset: 0.6 },
          { transform: 'rotate(0.6deg)', offset: 0.8 },
          { transform: 'rotate(0deg)' }
        ], o),
        lid.animate([ // the lid jumps a little, so the dark opening flashes under it
          { transform: 'translateY(0)' },
          { transform: 'translateY(-30%) rotate(-2deg)', offset: 0.22 },
          { transform: 'translateY(0)', offset: 0.42 },
          { transform: 'translateY(-14%) rotate(1deg)', offset: 0.6 },
          { transform: 'translateY(0)' }
        ], o),
        shadow.animate([ // v3.4d: small, the layer now holds a long cast that would swing with a bigger scale
          { transform: 'scaleX(1)' },
          { transform: 'scaleX(0.985)', offset: 0.18 },
          { transform: 'scaleX(0.99)', offset: 0.4 },
          { transform: 'scaleX(1)' }
        ], o)
      ];
    }
    function stopIdle() {
      for (var i = 0; i < idleTimers.length; i++) window.clearTimeout(idleTimers[i]);
      idleTimers = [];
      for (var j = 0; j < idleAnims.length; j++) idleAnims[j].cancel();
      idleAnims = [];
    }
    // Two wobbles, at 0,9 s and 3,7 s after S1 opens: both done by 4,6 s, so the auto-started motion stays under 5 s
    function scheduleIdle() {
      stopIdle();
      if (reduced() || !canAnimate) return;
      idleTimers.push(window.setTimeout(wobble, 900));
      idleTimers.push(window.setTimeout(wobble, 3700));
    }
    function peek(on) {
      if (rstate !== 'idle' || reduced() || dragging) { dlg.classList.remove('is-peek'); return; }
      if (on) for (var i = 0; i < idleAnims.length; i++) idleAnims[i].cancel();
      dlg.classList.toggle('is-peek', on);
    }

    // ------------------------------------------------------------------------------------------ drag the lid open
    // Drag up on the Dose: the lid follows with rubber-band resistance; past half a lid height it pops and the same
    // reveal runs. An extra, never the only way: tap, button, keyboard and screen reader paths are unchanged. v3.4d:
    // the drag starts only on the Dose ([data-np-tin], touch-action: none in CSS); elsewhere the picture scrolls the
    // sheet (touch-action: pan-y) and a tap on it still opens the lid.
    var swallowClick = false;
    var dragging = false;
    var dragStart = null;
    var DRAG_POP = 0.5;
    function lidH() { return lidWrap.offsetHeight || 1; }
    function endDrag(cancelled) {
      if (!dragging) { dragStart = null; return; }
      dragging = false;
      dragStart = null;
      dlg.classList.remove('is-dragging');
      lidWrap.style.transform = ''; // springs back via the CSS transition
      if (cancelled && rstate === 'idle') scheduleIdle();
    }

    // ------------------------------------------------------------------------------------------ powder (canvas)
    // Fine matte powder, not bubbles or glitter: 0,4–1,1 px warm-white specks at 0,5–0,7 alpha, slightly stretched
    // along their motion, spawned above the rim and never drawn below it, plus 5 flat soft puffs. Seeded: every run
    // is the same; a pure function of t.
    var particles = [];
    var fxCtx = null;
    var fxW = 0, fxH = 0, ox = 0, oy = 0, rimY = 0, scale = 1;
    function rng(seed) { return function () { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; }; }
    function setupFx() {
      if (!fx || !media || !group || !fx.getContext) return;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var mr = media.getBoundingClientRect(), sr = group.getBoundingClientRect();
      if (!mr.width || !sr.height) return;
      fxW = mr.width; fxH = mr.height;
      fx.width = Math.round(fxW * dpr); fx.height = Math.round(fxH * dpr);
      fxCtx = fx.getContext('2d');
      if (!fxCtx) return;
      fxCtx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ox = sr.left - mr.left + sr.width * 0.4964;   // the opening's centre
      rimY = sr.top - mr.top + sr.height * 0.03;     // the front lip of the rim
      oy = rimY - sr.height * 0.012;                 // spawn just above it
      scale = sr.height / 150;
      var r = rng(20261027);
      particles = [];
      for (var i = 0; i < 76; i++) {
        var a = (-90 + (r() * 2 - 1) * 55) * Math.PI / 180, v = (70 + r() * 150) * scale;
        particles.push({ k: 's', vx: Math.cos(a) * v, vy: Math.sin(a) * v, d: 3.4, g: 230 * scale,
          r: 0.4 + r() * 0.7, al: 0.5 + r() * 0.2, life: 460 + r() * 300, delay: r() * 110, x0: (r() * 2 - 1) * 26 * scale });
      }
      for (var j = 0; j < 5; j++) {
        var b = (-90 + (r() * 2 - 1) * 35) * Math.PI / 180, w = (30 + r() * 40) * scale;
        particles.push({ k: 'p', vx: Math.cos(b) * w, vy: Math.sin(b) * w, d: 2.4, g: -12 * scale,
          r: (8 + r() * 7) * scale, life: 520 + r() * 160, delay: r() * 60, x0: (r() * 2 - 1) * 18 * scale });
      }
    }
    function clearFx() { if (fxCtx) fxCtx.clearRect(0, 0, fxW, fxH); }
    function drawFx(t) {
      if (!fxCtx) return;
      fxCtx.clearRect(0, 0, fxW, fxH);
      var lt0 = t - PUFF_START;
      if (lt0 <= 0 || t >= PUFF_END) return;
      fxCtx.save();
      fxCtx.beginPath(); fxCtx.rect(0, 0, fxW, rimY); fxCtx.clip(); // nothing over the front of the tin
      fxCtx.lineCap = 'round';
      for (var i = 0; i < particles.length; i++) {
        var p = particles[i], lt = lt0 - p.delay;
        if (lt <= 0 || lt >= p.life) continue;
        var s = lt / 1000, e = Math.exp(-p.d * s), k = (1 - e) / p.d;
        var x = ox + p.x0 + p.vx * k, y = oy + p.vy * k + 0.5 * p.g * s * s;
        var u = lt / p.life, alpha = Math.min(1, lt / 50) * (1 - u * u);
        if (p.k === 's') {
          var vx = p.vx * e, vy = p.vy * e + p.g * s, sp = Math.sqrt(vx * vx + vy * vy) || 1;
          var len = Math.min(3.2, sp * 0.012);
          fxCtx.strokeStyle = 'rgba(251,248,242,' + (alpha * p.al).toFixed(3) + ')';
          fxCtx.lineWidth = p.r * 2;
          fxCtx.beginPath(); fxCtx.moveTo(x - vx / sp * len, y - vy / sp * len); fxCtx.lineTo(x, y); fxCtx.stroke();
        } else {
          var rr = p.r * (1 + 1.4 * u), g = fxCtx.createRadialGradient(x, y, 0, x, y, rr);
          g.addColorStop(0, 'rgba(251,248,242,' + (alpha * 0.32).toFixed(3) + ')');
          g.addColorStop(1, 'rgba(251,248,242,0)');
          fxCtx.fillStyle = g;
          fxCtx.save(); fxCtx.translate(x, y); fxCtx.scale(1.5, 0.75); fxCtx.translate(-x, -y); // flat, not a round glow
          fxCtx.beginPath(); fxCtx.arc(x, y, rr, 0, 6.2832); fxCtx.fill();
          fxCtx.restore();
        }
      }
      fxCtx.restore();
    }
    function fxLoop() {
      if (!master || rstate !== 'revealing') return;
      var t = master.currentTime || 0;
      drawFx(t);
      if (master.playState === 'running' && t < PUFF_END) rafId = window.requestAnimationFrame(fxLoop);
      else if (t >= PUFF_END) drawFx(PUFF_END);
    }

    // ------------------------------------------------------------------------------------------ the reveal
    function buildMotion(from) {
      var H = group.offsetHeight, W = group.offsetWidth;
      // each animation goes into `anims` as soon as it starts, so a throw half-way (cancelReveal) can stop the ones
      // already running (fill: both)
      var list = anims;
      var add = function (el, kf, opt) { opt.fill = 'both'; list.push(el.animate(kf, opt)); };
      var px = function (v) { return v.toFixed(1) + 'px'; };

      // tin: squash (anticipation) → stretch + small hop → settle; a small nudge when the lid lands against it
      add(tin, [
        { transform: 'none', easing: 'ease-out' },
        { transform: 'scale(1.035, 0.94)', offset: 0.09, easing: 'cubic-bezier(0.2, 0.7, 0.3, 1)' },
        { transform: 'translateY(' + px(-0.05 * H) + ') scale(0.98, 1.04)', offset: 0.23, easing: 'ease-in' },
        { transform: 'scale(1.02, 0.975)', offset: 0.37, easing: 'ease-out' },
        { transform: 'scale(0.995, 1.01)', offset: 0.47 },
        { transform: 'none', offset: 0.6 },
        { transform: 'rotate(0.9deg)', offset: 0.66, easing: 'ease-out' },
        { transform: 'rotate(-0.4deg)', offset: 0.75 },
        { transform: 'none' }
      ], { duration: 1000 });
      // its shadow stays on the floor: a little wider at the squash; while the tin is in the air the contact line
      // mostly goes (opacity 0,4 at the top of the hop), so no sharp dark disc sits under a tin in the air (v3.4d)
      add(shadow, [
        { transform: 'none', opacity: 1 },
        { transform: 'scaleX(1.02)', opacity: 1, offset: 0.16 },
        { transform: 'scale(0.97)', opacity: 0.4, offset: 0.4 },
        { transform: 'scaleX(1.01)', opacity: 1, offset: 0.66 },
        { transform: 'none', opacity: 1 }
      ], { duration: 560 });

      // lid: pops up off the right flange, arcs up-left, comes down and lands leaning against the Dose; at touchdown the
      // 2-D flying lid hands over to the real photo of the leaning lid (crossfade)
      lidWrap.style.transform = '';
      lidWrap.style.transition = 'none';
      var LX = -0.75 * W, LY = 0.61 * H;
      add(lid, [
        { transform: from === 'drag' ? 'translateY(-55%) rotate(-3deg)' : 'none', opacity: 1, easing: 'cubic-bezier(0.2, 0.9, 0.3, 1.25)' },
        { transform: 'translate(' + px(-0.02 * W) + ',' + px(-0.3 * H) + ') rotate(-12deg)', opacity: 1, offset: 0.22, easing: 'cubic-bezier(0.3, 0.2, 0.6, 1)' },
        { transform: 'translate(' + px(-0.42 * W) + ',' + px(-0.36 * H) + ') rotate(-38deg) scale(1.02, 1.15)', opacity: 1, offset: 0.48, easing: 'cubic-bezier(0.5, 0, 0.85, 0.5)' },
        { transform: 'translate(' + px(LX) + ',' + px(LY + 0.02 * H) + ') rotate(-73deg) scale(1.05, 1.55)', opacity: 1, offset: 0.87, easing: 'ease-out' },
        { transform: 'translate(' + px(LX) + ',' + px(LY) + ') rotate(-70deg) scale(1.05, 1.6)', opacity: 0, offset: 0.91 },
        { transform: 'translate(' + px(LX) + ',' + px(LY) + ') rotate(-70deg) scale(1.05, 1.6)', opacity: 0 }
      ], { duration: 760, delay: 60 });
      // touchdown ≈ 720 ms: the photo takes over in ~30 ms (689–722 ms) and the flying lid fades 721–752 ms, so the
      // two lids are never both clearly visible (v3.4c overlapped them for ~130 ms: a double lid)
      add(lean, [
        { opacity: 0 },
        { opacity: 0, offset: 0.84 },
        { opacity: 1, offset: 0.88 },
        { opacity: 1 }
      ], { duration: 820 });
      add(leanShadow, [ // its contact + cast shadow lands with it
        { opacity: 0 },
        { opacity: 0, offset: 0.84 },
        { opacity: 1, offset: 0.9 },
        { opacity: 1 }
      ], { duration: 820 });

      // a soft, flat powder cloud from the opening (one sprite, peak 0,5); the canvas adds the fine specks
      add(cloud, [
        { transform: 'translateY(10%) scale(0.5, 0.35)', opacity: 0 },
        { transform: 'translateY(0) scale(0.95, 0.6)', opacity: 0.5, offset: 0.2 },
        { transform: 'translateY(-10%) scale(1.3, 0.8)', opacity: 0 }
      ], { duration: 560, delay: 100, easing: 'cubic-bezier(0.2, 0.6, 0.35, 1)' });

      // the „5 € / CODE“ card: rises out of the opening (clipped at the rim), springs, settles standing in the tin
      add(chip, [
        { transform: 'translateY(135%)', opacity: 1 },
        { transform: 'translateY(10%)', opacity: 1 }
      ], { duration: 720, delay: 220, easing: SPRING_CHIP });
      add(chipIn, [
        { transform: 'rotate(4deg)' },
        { transform: 'rotate(-10deg)', offset: 0.35 },
        { transform: 'rotate(-1deg)', offset: 0.6 },
        { transform: 'rotate(-6.5deg)', offset: 0.82 },
        { transform: 'rotate(-5deg)' }
      ], { duration: 900, delay: 220, easing: 'ease-in-out' });

      // the steps: a short press (110 ms), „Deckel auf“ fades, the form rises in under the same offer line
      revealBtn.classList.add('is-pressed');
      window.clearTimeout(pressTimer);
      pressTimer = window.setTimeout(function () { revealBtn.classList.remove('is-pressed'); }, 110);
      add(doseStep, [
        { opacity: 1 },
        { opacity: 1, offset: 0.55 },
        { opacity: 0 }
      ], { duration: 600, delay: 40, easing: 'ease-out' });
      add(formStep, [
        { opacity: 0, transform: 'translateY(8px)' },
        { opacity: 1, transform: 'none' }
      ], { duration: 320, delay: 560, easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)' });

      window.requestAnimationFrame(function () { lidWrap.style.transition = ''; });
      return { total: TOTAL };
    }

    // Reduced motion: 200 ms, opacity only. The lid fades out while the card and the leaning lid fade in; the two
    // control rows hand over (out 0–100 ms, in 100–200 ms), so button and field never overlap
    function buildReduced() {
      var o = { duration: TOTAL_RM, easing: 'linear', fill: 'both' };
      anims.push(lidWrap.animate([{ opacity: 1 }, { opacity: 0 }], o));
      anims.push(chip.animate([{ opacity: 0 }, { opacity: 1 }], o));
      anims.push(lean.animate([{ opacity: 0 }, { opacity: 1 }], o));
      anims.push(leanShadow.animate([{ opacity: 0 }, { opacity: 1 }], o));
      anims.push(doseStep.animate([{ opacity: 1 }, { opacity: 0, offset: 0.5 }, { opacity: 0 }], o));
      anims.push(formStep.animate([{ opacity: 0 }, { opacity: 0, offset: 0.5 }, { opacity: 1 }], o));
      return { total: TOTAL_RM };
    }

    function cancelReveal() {
      window.cancelAnimationFrame(rafId);
      window.clearTimeout(liveTimer);
      for (var i = 0; i < anims.length; i++) anims[i].cancel();
      anims = [];
      if (master) { master.cancel(); master = null; }
      clearFx();
    }

    function reveal(from) {
      if (rstate !== 'idle' || !isOpen() || !stage || stage.getAttribute('data-step') !== 'dose') return;
      timing = { start: Date.now(), live: 0, end: 0, skipped: false, from: from || 'button' };
      stopIdle();
      dlg.classList.remove('is-peek');
      closeConditions();
      rstate = 'revealing';
      formLive = false;
      if (revealBtn) revealBtn.setAttribute('aria-disabled', 'true');
      dlg.classList.add('is-revealing');
      var rm = reduced();
      dlg.classList.toggle('is-rm', rm);
      var m;
      cancelReveal(); // anims = [] before the build fills it
      try {
        m = rm ? buildReduced() : buildMotion(from);
        // a target-less clock: no animation on body or any element
        master = new window.Animation(new window.KeyframeEffect(null, [], { duration: m.total }), document.timeline);
        master.play();
        master.finished.then(finish, function () {});
      } catch (err) {
        // a browser that rejects a keyframe or easing half-way: finish() cancels what already runs (cancelReveal) and
        // the end state comes from the classes; the lid's hover/drag transition comes back
        if (lidWrap) lidWrap.style.transition = '';
        finish();
        return;
      }
      // the form goes live as soon as it starts to show: only the decorative layers run on
      window.clearTimeout(liveTimer);
      liveTimer = window.setTimeout(goLive, rm ? TOTAL_RM / 2 : LIVE_AT);
      if (!rm) {
        if (!fxCtx) setupFx();
        rafId = window.requestAnimationFrame(fxLoop);
        // Android haptic tick at the pop: never from the keyboard, only with user activation (else Chrome blocks it)
        var act = navigator.userActivation;
        if (from !== 'key' && typeof navigator.vibrate === 'function' && (!act || act.isActive)) {
          try { navigator.vibrate(8); } catch (e) {}
        }
      }
    }

    function goLive() {
      if (formLive || (rstate !== 'revealing' && rstate !== 'done')) return;
      formLive = true;
      timing.live = Date.now();
      var hadFocus = doseStep && doseStep.contains(document.activeElement);
      setStep('form');
      if (hadFocus) focusEl(line);
    }

    // End state held by classes, not by fill: after the reveal no animation remains
    function finish() {
      if (rstate !== 'revealing') return;
      cancelReveal();
      dlg.classList.add('is-open-tin');
      goLive();
      dlg.classList.remove('is-revealing');
      rstate = 'done';
      timing.end = Date.now();
      if (revealBtn) revealBtn.removeAttribute('aria-disabled');
      // focus: the line, unless the visitor is already in the form (a tap on the field during the reveal keeps it)
      var ae = document.activeElement;
      if (!ae || ae === document.body || ae === dlg || (!formStep.contains(ae) && ae !== line && !(line && line.contains(ae)))) {
        focusEl(line);
      }
    }

    // A second tap (or Enter / Space) skips to the end. Guard: taps within 400 ms of the reveal tap (a double tap)
    // can't land on the field or „Anmelden"; after that a tap on the field focuses it at once.
    function skip(e) {
      if (rstate !== 'revealing') return;
      var since = Date.now() - timing.start;
      if (since < GUARD) {
        dlg.classList.add('is-settling');
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(function () { dlg.classList.remove('is-settling'); }, GUARD - since);
      }
      timing.skipped = true;
      finish();
      if (e && since >= GUARD && typeof e.clientX === 'number' && input) {
        var r = input.getBoundingClientRect();
        if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) focusEl(input);
      }
    }

    // Back to rest before a (re)open: no reveal running, no end state, no idle motion
    function resetScene() {
      stopIdle();
      endDrag(false);
      cancelReveal();
      window.clearTimeout(settleTimer);
      window.clearTimeout(pressTimer);
      dlg.classList.remove('is-open-tin', 'is-revealing', 'is-settling', 'is-peek', 'is-dragging');
      if (revealBtn) { revealBtn.removeAttribute('aria-disabled'); revealBtn.classList.remove('is-pressed'); }
      if (lidWrap) lidWrap.style.transform = '';
      formLive = false;
      rstate = 'done';
    }

    if (revealBtn) revealBtn.addEventListener('click', function (e) {
      if (rstate === 'revealing') { skip(e.detail === 0 ? null : e); return; }
      if (revealBtn.getAttribute('aria-disabled') === 'true') return;
      reveal(e.detail === 0 ? 'key' : 'button');
    });

    if (media && canAnimate) {
      media.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') peek(true); });
      media.addEventListener('pointerleave', function () { if (!dragging) peek(false); });
      media.addEventListener('pointerdown', function (e) {
        swallowClick = false;
        if (rstate !== 'idle' || reduced() || e.button > 0) return;
        if (!tin.contains(e.target)) return; // only the Dose starts a drag
        dragStart = { x: e.clientX, y: e.clientY, id: e.pointerId, moved: false };
      });
      media.addEventListener('pointermove', function (e) {
        if (!dragStart || e.pointerId !== dragStart.id || rstate !== 'idle') return;
        var dy = dragStart.y - e.clientY, dx = e.clientX - dragStart.x;
        if (!dragStart.moved) {
          if (dy < 6 || Math.abs(dx) > dy) return; // not an upward drag (yet)
          dragStart.moved = true;
          dragging = true;
          swallowClick = true; // the click after a drag is not a tap
          try { media.setPointerCapture(e.pointerId); } catch (err) {}
          stopIdle();
          dlg.classList.remove('is-peek');
          dlg.classList.add('is-dragging');
        }
        var h = lidH(), lift = h * 1.2 * (1 - Math.exp(-Math.max(0, dy) / (h * 2.4))); // rubber band
        var f = lift / h;
        lidWrap.style.transform = 'translateY(' + (-lift).toFixed(1) + 'px) rotate(' + (-6 * f).toFixed(2) + 'deg)';
        if (f >= DRAG_POP) { endDrag(false); reveal('drag'); }
      });
      media.addEventListener('pointerup', function () { if (dragging) endDrag(true); dragStart = null; });
      media.addEventListener('pointercancel', function () { endDrag(true); });
    }
    if (media) media.addEventListener('click', function (e) {
      if (swallowClick) { swallowClick = false; return; }
      if (rstate === 'revealing') skip(e); else if (rstate === 'idle') reveal('tap');
    });
    if (revealBtn && canAnimate) {
      revealBtn.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') peek(true); });
      revealBtn.addEventListener('pointerleave', function () { if (document.activeElement !== revealBtn) peek(false); });
      revealBtn.addEventListener('focus', function () {
        var fv = false;
        try { fv = revealBtn.matches(':focus-visible'); } catch (e) {}
        if (fv) peek(true);
      });
      revealBtn.addEventListener('blur', function () { peek(false); });
    }
    // During the reveal a tap anywhere else in the sheet (not ×, not the backdrop) or Enter/Space skips to the end
    dlg.addEventListener('pointerdown', function (e) {
      if (rstate !== 'revealing' || e.target === dlg || !e.target.closest || e.target.closest('[data-newsletter-popup-close]')) return;
      if (e.target.closest('[data-newsletter-reveal]') || e.target.closest('[data-newsletter-reveal-media]')) return; // their click handles it
      if (formLive && formStep && formStep.contains(e.target)) return; // the form is live: let the tap through
      e.preventDefault();
      skip(e);
    });
    dlg.addEventListener('keydown', function (e) {
      if (rstate !== 'revealing' || (e.key !== 'Enter' && e.key !== ' ')) return;
      if (e.target.closest && (e.target.closest('[data-newsletter-popup-close]') || e.target.closest('[data-newsletter-more-toggle]'))) return;
      if (formStep && formStep.contains(e.target)) return;
      e.preventDefault();
      skip();
    });
    window.addEventListener('resize', function () { if (isOpen() && rstate === 'idle') setupFx(); });

    function open(mode) {
      if (isOpen() || !document.documentElement.contains(dlg)) return;
      finished = true;
      disarm();
      opener = document.activeElement;
      // S1 only on the normal open; success, error and footer-POST views always show the form with the Set photo
      var a = mode === 'form' ? chooseArm() : 'single';
      if (a === 'reveal' && !design && layers !== 'ready') a = 'single'; // fail closed: a layer missing or not decoded
      if (a === 'reveal') loadLayers(); // the editor: load now if not yet
      else preloadPhoto(dlg);
      setArm(a);
      resetScene();
      dlg.classList.toggle('is-rm', reduced());
      setStep(a === 'reveal' ? 'dose' : 'form');
      if (a === 'reveal') rstate = 'idle';
      // Shown = asked: no second popup in another tab of this browser session (v3.3.1; before, only on close)
      if (mode === 'form' && !design) setFlag();
      dlg.classList.toggle('is-success', mode === 'success');
      modal = false;
      if (typeof dlg.showModal === 'function') {
        try { dlg.showModal(); modal = true; } catch (e) { dlg.setAttribute('open', ''); }
      } else {
        dlg.setAttribute('open', '');
      }
      // aria-modal only while the dialog really is modal (v3.2.1)
      if (modal) dlg.setAttribute('aria-modal', 'true'); else dlg.removeAttribute('aria-modal');
      void dlg.offsetWidth; // start the transition from the closed position
      dlg.classList.add('is-visible');
      if (a === 'reveal') {
        setupFx(); // layout read + canvas at open, not on the tap
        scheduleIdle();
      }

      // After a POST: the status line, success or error. It sits at the top of the sheet, while the e-mail field is
      // below the consent text and can be under the fold on a small phone (role=status / role=alert, tabindex=-1).
      // Otherwise the heading (v3.4: it carries the offer; no focus ring on × at the start).
      var target = null;
      if (mode === 'success' || mode === 'error') target = dlg.querySelector('[data-newsletter-status]');
      if (!target) target = title || closeBtn;
      focusEl(target);
    }

    function restoreFocus() {
      var el = opener;
      opener = null;
      if (el && el !== document.body && typeof el.focus === 'function' && document.documentElement.contains(el)) {
        try { el.focus({ preventScroll: true }); } catch (e) {}
      }
    }

    // × , Esc and the backdrop close in every state, also during the reveal (it jumps to its end state first)
    function close() {
      if (!isOpen() || closing) return;
      closing = true;
      stopIdle();
      endDrag(false);
      if (rstate === 'revealing') finish();
      if (!design) setFlag();
      dlg.classList.remove('is-visible');
      var done = function () {
        closing = false;
        if (typeof dlg.close === 'function' && dlg.open) dlg.close();
        else dlg.removeAttribute('open');
        restoreFocus();
      };
      if (reduced()) done(); else window.setTimeout(done, CLOSE_MS);
    }

    // Esc: animate instead of the instant native close
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    // A close that bypassed close() (e.g. a browser forcing Esc): same bookkeeping
    dlg.addEventListener('close', function () {
      if (dlg.open) return; // demoted to non-modal on submit (below), not a real close
      modal = false;
      stopIdle();
      dlg.classList.remove('is-visible');
      if (!design) setFlag();
      if (!closing) restoreFocus();
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    // Backdrop click (the panel fills the dialog box, so only the backdrop targets the dialog itself)
    dlg.addEventListener('pointerdown', function (e) { downOnBackdrop = e.target === dlg; });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg && downOnBackdrop) close();
      downOnBackdrop = false;
    });
    // A sent sign-up ends the popup for this session, whatever Shopify answers.
    // Leave the top layer before Shopify's hCaptcha runs: its challenge is appended to <body> (the provider passes no
    // challenge-container), and a modal dialog makes <body> inert and paints above any z-index. Registered at init,
    // before Shopify's provider binds its own submit listener on focusin, so it runs first; the submit event fires
    // only after validation. Looks the same (position: fixed, z-index 1200 < hCaptcha's 2e9), only the backdrop goes.
    if (form && !design) form.addEventListener('submit', function () {
      setFlag();
      if (rstate === 'revealing') finish();
      if (!modal || !isOpen()) return;
      modal = false;
      var a = document.activeElement;
      dlg.close();
      dlg.show();
      // Non-modal now: without this, VoiceOver could still treat the page outside the dialog, including hCaptcha's
      // challenge, as hidden (v3.2.1)
      dlg.removeAttribute('aria-modal');
      if (a && dlg.contains(a)) { try { a.focus({ preventScroll: true }); } catch (e) {} }
    });
    // A non-modal dialog gets no 'cancel' event: keep Esc working after the demotion (and without showModal)
    dlg.addEventListener('keydown', function (e) {
      if (!modal && isOpen() && (e.key === 'Escape' || e.key === 'Esc')) close();
    });

    function blocked() {
      if (document.hidden) return true;
      if (document.querySelector(BLOCKERS)) return true;
      var dialogs = document.querySelectorAll('dialog[open]');
      for (var i = 0; i < dialogs.length; i++) if (dialogs[i] !== dlg) return true;
      if (shown(document.getElementById('shopify-pc__banner')) || shown(document.getElementById('shopify-pc__prefs'))) return true;
      var a = document.activeElement;
      if (a && a !== document.body && (/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) || a.isContentEditable)) return true;
      return false;
    }

    function tryOpen() {
      if (finished || flagged()) { disarm(); return; }
      if (blocked()) {
        window.clearTimeout(retry);
        retry = window.setTimeout(tryOpen, 3000);
        return;
      }
      open('form');
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var root = document.documentElement;
        var max = Math.max(root.scrollHeight, document.body ? document.body.scrollHeight : 0) - window.innerHeight;
        var y = window.pageYOffset || root.scrollTop || 0;
        if (max > 0 && y / max >= depth) tryOpen();
      });
    }

    function arm() {
      if (armed || finished || flagged()) return;
      armed = true;
      setArm(chooseArm());
      if (shownArm === 'reveal') loadLayers(); else preloadPhoto(dlg);
      timer = window.setTimeout(tryOpen, delay);
      if (depth > 0) window.addEventListener('scroll', onScroll, { passive: true });
    }

    function disarm() {
      window.clearTimeout(timer);
      window.clearTimeout(retry);
      window.removeEventListener('scroll', onScroll);
    }

    // ---- Theme editor: open on select, close on deselect; never automatic, never stored
    if (design) {
      preloadPhoto(dlg);
      loadLayers();
      dlg.additNewsletterOpen = function () { open('form'); };
      document.addEventListener('shopify:section:select', function (e) {
        if (e.detail && e.detail.sectionId === dlg.getAttribute('data-section-id')) open('form');
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.detail && e.detail.sectionId === dlg.getAttribute('data-section-id')) close();
      });
      return;
    }

    // ---- The page after a POST: which form was sent?
    var hash = window.location.hash;
    var status = form ? form.querySelector('[data-newsletter-status]') : null;
    if (hash === '#' + formId) {
      // The popup was sent: every other form hides its copy of the page-wide state ...
      var all = document.querySelectorAll('[data-newsletter-status]');
      for (var i = 0; i < all.length; i++) if (!dlg.contains(all[i])) all[i].hidden = true;
      // ... and drops the invalid marking and the refilled address the page-wide form.errors put on its e-mail field
      // (aria-describedby still reads hidden text, and [aria-invalid] draws the ink border)
      var bad = document.querySelectorAll('.newsletter-form__input[aria-invalid]');
      for (var j = 0; j < bad.length; j++) {
        if (!dlg.contains(bad[j])) {
          bad[j].removeAttribute('aria-invalid');
          bad[j].removeAttribute('aria-describedby');
          bad[j].value = '';
        }
      }
      if (status) {
        open(status.getAttribute('data-newsletter-status') === 'success' ? 'success' : 'error');
        // A reload must not show it again
        try {
          var url = window.location.pathname + window.location.search.replace(/([?&])customer_posted=true(&|$)/, function (m, p1, p2) { return p2 ? p1 : ''; });
          window.history.replaceState(window.history.state, '', url);
        } catch (e) {}
      }
      return;
    }
    if (status) {
      // Another form (the footer) was sent on this page view: don't ask again now; after a sign-up, not this session
      if (status.getAttribute('data-newsletter-status') === 'success') setFlag();
      return;
    }

    // ---- Normal page view
    if (flagged()) return;
    // The answer to the banner on this page view: the timer starts now
    document.addEventListener('visitorConsentCollected', arm);
    // Answered on an earlier visit: the timer starts as soon as the page is ready (init runs at DOMContentLoaded; v3.1
    // waited for window load, which comes late on pages with video)
    withPrivacyApi(function (cp) { if (consentAnswered(cp)) arm(); });
  }

  function initAll() {
    var list = document.querySelectorAll('[data-newsletter-popup]');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  // Theme editor: a settings change re-renders the section; bind the new dialog and show it
  document.addEventListener('shopify:section:load', function (e) {
    var dlg = e.target && e.target.querySelector && e.target.querySelector('[data-newsletter-popup]');
    if (!dlg) return;
    init(dlg);
    if (typeof dlg.additNewsletterOpen === 'function') { dlg.additNewsletterOpen(); return; }
    try { if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', ''); dlg.classList.add('is-visible'); } catch (err) {}
  });
})();
